import { describeAgent, isMobileAgent, relativeTime } from '../../lib/format.js'
import { fullDate } from '../../lib/time.js'

const Fez = window.Fez;
if (!Fez) throw new Error('fez runtime not loaded: load fez (window.Fez) before component modules');

// --- tpl-sessions ---
let __fez_component_0;
{

__fez_component_0 = class {
  init() {
    this.state.loading = true
    this.state.error = ''
    this.state.items = []
    this.state.busy = ''
  }

  onMount() {
    this.load()
  }

  async load() {
    try {
      const list = await window.App.api('session/list', {}, { silent: true })
      this.state.items = list.items
      this.state.error = ''
    } catch (error) {
      this.state.error = error.message
    } finally {
      this.state.loading = false
    }
  }

  async revoke(ref) {
    const item = this.state.items.find((session) => session.ref === ref)
    if (item?.current) return window.App.signOut()
    this.state.busy = ref
    try {
      await window.App.api(`session/${ref}/revoke`)
      await this.load()
    } finally {
      this.state.busy = ''
    }
  }

  async revokeOthers() {
    const others = this.state.items.filter((session) => !session.current)
    const ok = await window.Dialog.confirm({ title: 'Sign out other sessions?', text: `${others.length === 1 ? 'One other browser is' : `${others.length} other browsers are`} signed out right away.`, confirm: 'Sign out', danger: true })
    if (!ok) return
    this.state.busy = 'others'
    try {
      for (const session of others) await window.App.api(`session/${session.ref}/revoke`, {}, { silent: true })
      window.Toast?.success('Other sessions signed out')
      await this.load()
    } finally {
      this.state.busy = ''
    }
  }

  beforeRender() {
    this.state.rows = this.state.items.map((session) => ({
      ...session,
      device: describeAgent(session.user_agent),
      icon: isMobileAgent(session.user_agent) ? 'device-mobile' : 'desktop',
      used: session.current ? 'Active now' : `Last active ${relativeTime(session.last_used_at)}`,
      since: `Signed in ${fullDate(session.created_at)}`,
    }))
    this.state.others = this.state.items.filter((session) => !session.current).length
  }

  CSS = `:fez {
display:block;.sessions-page{max-width:var(--content-width);margin:0 auto;padding:var(--space-10) var(--space-6) var(--space-12)}.sessions-head{display:flex;align-items:flex-end;justify-content:space-between;gap:var(--space-4);margin-bottom:var(--space-6)}h1{font-size:var(--text-2xl);letter-spacing:-0.02em}.sessions-sub{margin-top:var(--space-2);color:var(--color-text-muted)}.session-icon{display:grid;place-items:center;width:40px;height:40px;flex:none;border-radius:var(--radius-lg);background:var(--color-bg-subtle);color:var(--color-text-muted)}.session-title{display:flex;flex-wrap:wrap;align-items:center;gap:var(--space-2);font-weight:var(--weight-semibold)}.session-meta{color:var(--color-text-muted);font-size:var(--text-sm)} :mobile {.sessions-page{padding:var(--space-6) var(--space-4) var(--space-10)}.sessions-head{flex-direction:column;align-items:stretch}}
}`

  HTML = `<div class="sessions-page">
<div class="sessions-head">
<div>
<h1>Sessions</h1>
<p class="sessions-sub">Browsers signed in to your account. Sign out any you do not recognize.</p>
</div>
{#if state.others}
<ui-button variant="danger-ghost" icon="sign-out" label="Sign out other sessions" loading={state.busy === 'others'} onclick="fez.revokeOthers()"></ui-button>
{/if}
</div>
{#if state.error}
<ui-empty icon="warning-circle" title="Could not load your sessions" text={state.error}></ui-empty>
{:else if state.loading}
<ui-spinner></ui-spinner>
{:else}
<ui-card padding="none">
{#each state.rows as session}
<div class="list-row" key={session.ref}>
<span class="session-icon"><ui-icon name={session.icon} size="20"></ui-icon></span>
<div class="list-main">
<div class="session-title">{session.device}{#if session.current}<ui-badge tone="success" label="This browser"></ui-badge>{/if}</div>
<div class="session-meta">{session.ip || 'Unknown IP'} · {session.used}</div>
<div class="session-meta">{session.since}</div>
</div>
<ui-button size="sm" variant="ghost" icon="sign-out" label="Sign out" loading={state.busy === session.ref} onclick="fez.revoke('{session.ref}')"></ui-button>
</div>
{/each}
</ui-card>
{/if}
</div>`
};
}

Fez('tpl-sessions', __fez_component_0);

export default __fez_component_0;
